// extracted by mini-css-extract-plugin
export default {"fulfilled":"styles_fulfilled__CrgTP","image":"styles_image__-bmnj","wideImage":"styles_wideImage__2C5cH","title":"styles_title__R75jQ","mirrored":"styles_mirrored__EDfOu"};